import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Link from '@swf/components/Link/Link';
import type { Dispatch } from '@swf/core/store';
import { select } from '@swf/core/store';

import CMSHTML from '../../../../../CMSHTML/CMSHTML';
import CMSImage from '../../../../../CMSImage/CMSImage';
import type { Props } from '../../TopHeader';

import styles from './RegulatoryHeaderES.scss';

const RegulatoryHeaderES: React.FC<Props> = ({
  regulatory_header: [
    {
      texts: [{ content }],
      icons: [icon]
    }
  ]
}) => {
  const isAuthenticated = useSelector(select.session.isAuthenticated);
  const selfExclusionModalPath = '/account/responsible/take-a-break-from-us';

  const { modal } = useDispatch<Dispatch>();

  const openSelfExcludeModal = () =>
    modal.enqueue(
      isAuthenticated
        ? { path: selfExclusionModalPath }
        : { path: '/auth/login', locationState: { path: selfExclusionModalPath } }
    );

  return (
    <div className={styles.container}>
      <Link onClick={openSelfExcludeModal} className={styles.wrapper} trackText="Self-Exclusion">
        <CMSImage {...icon} />
        <CMSHTML content={content} />
      </Link>
    </div>
  );
};

export default RegulatoryHeaderES;
